var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaintbucket(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#4d170a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M156.7 102.1L221.1 37.66C249.2 9.539 294.8 9.539 322.9 37.66L474.3 189.1C502.5 217.2 502.5 262.8 474.3 290.9L283.9 481.4C246.4 518.9 185.6 518.9 148.1 481.4L30.63 363.9C-6.863 326.4-6.863 265.6 30.63 228.1L134.1 124.7L36.69 27.31C30.44 21.07 30.44 10.93 36.69 4.686C42.93-1.562 53.07-1.562 59.31 4.686L156.7 102.1zM53.25 250.7C42.8 261.2 36.71 274.4 35.01 288H432L451.7 268.3C467.3 252.7 467.3 227.3 451.7 211.7L300.3 60.28C284.7 44.66 259.3 44.66 243.7 60.28L179.3 124.7L267.3 212.7C273.6 218.9 273.6 229.1 267.3 235.3C261.1 241.6 250.9 241.6 244.7 235.3L156.7 147.3L53.25 250.7zM170.7 458.7C195.7 483.7 236.3 483.7 261.3 458.7L400 320H39.16C42.29 327.7 46.98 334.1 53.25 341.3L170.7 458.7z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaintbucket);
export default __webpack_public_path__ + "static/media/paintbucket.24dbde55a606c94734bc6393ef703cbe.svg";
export { ForwardRef as ReactComponent };